export default __webpack_public_path__ + "static/media/LOGO.4d6c80ae.png";